import { Box, Skeleton, Stack, Typography } from '@customink/pigment-react';
import type { ProjectItem } from '@customink/project-service-react-components';
import { getHex } from '@customink/project-service-react-components';

import { GroupItemActions } from './GroupItemActions';
import { GroupItemProductColorInfo } from './GroupItemProductColorInfo';
import type { ProjectItemProductData } from '../EditGroupSizesForm/useGroupSizesForm';

import { ProjectItemProof } from '@/components/ProjectItem/ProjectItemProof';

export interface GroupItemHeaderProps {
  item: ProjectItem;
  productItemData: ProjectItemProductData;
  isMobile: boolean;
  groupItems: ProjectItem[];
  onDelete: (e: React.MouseEvent) => Promise<void>;
  onViewSizingGuide: (e: React.MouseEvent) => void;
}

export const GroupItemHeader = ({
  productItemData,
  groupItems,
  item,
  isMobile,
  onDelete,
  onViewSizingGuide,
}: GroupItemHeaderProps) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={isMobile ? '0.75rem' : undefined}
      justifyContent="space-between"
    >
      {isMobile && (
        <Box sx={{ width: '6rem' }}>
          <ProjectItemProof displayDraft={false} item={item} />
        </Box>
      )}

      <Stack flex={1} gap="0.25rem">
        <Typography variant="heading5">
          {productItemData.name || (
            <Skeleton data-testid="skeleton" width="80px" />
          )}
        </Typography>
        <GroupItemProductColorInfo
          color={getHex(productItemData.color) || ''}
          name={productItemData.color?.name}
        />
        {isMobile && (
          <GroupItemActions
            compact
            groupItemCount={groupItems.length}
            hasLineup={productItemData.hasLineup}
            onDelete={onDelete}
            onViewSizingGuide={onViewSizingGuide}
          />
        )}
      </Stack>
      {!isMobile && (
        <GroupItemActions
          groupItemCount={groupItems.length}
          hasLineup={productItemData.hasLineup}
          onDelete={onDelete}
          onViewSizingGuide={onViewSizingGuide}
        />
      )}
    </Box>
  );
};
